import { useEffect, useMemo } from "react";
import "./myprofileStyle.css";

import { FaBuilding, FaUsers, FaUserTie } from "react-icons/fa";
import { MdEmail, MdPhone, MdCheckCircle } from "react-icons/md";

import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

import profileImage from "../assets/imgs/profileImage.png";
import { getLocalStorage } from "../utils/localStorage";

const InfoCard = ({ icon: Icon, title, value }) => (
  <div className="info-card-n">
    <div className="info-card-n-top">
      <Icon className="info-card-n-icon" />
      <span>{title}</span>
    </div>

    <div className="info-card-n-value">
      {value || "Not Available"}
    </div>
  </div>
);

const ContactCard = ({ icon: Icon, label, value }) => (
  <div className="contact-card">
    <div className="contact-card-icon">
      <Icon />
    </div>

    <div>
      <div className="contact-label">{label}</div>
      <div className="contact-value">{value || "Not Available"}</div>
    </div>
  </div>
);

function MyProfile() {
  const currentUser = getLocalStorage("CURRENT_USER") || {};

  const {
    name,
    email,
    phone,
    orgId,
    processName,
    department,
    designation,
    reportingTo,
    role = [],
    active,
  } = currentUser;

  useEffect(() => {
    [
      "screenCache",
      "screenCache_child",
      "screenCacheallLeads",
    ].forEach((item) => localStorage.removeItem(item));
  }, []);

  const formattedName = useMemo(
    () =>
      name?.replace(/\b\w/g, (char) => char.toUpperCase()) ||
      "User",
    [name]
  );

  const roleName =
    role?.[0]?.replace("ROLE_", "").replaceAll("_", " ") ||
    "User";

  return (
    <div className="my-profile-container">
      <div className="profile-page-title">
        Profile Information
      </div>

      {/* Header */}
      <div className="profile-header">
        <div className="profile-left">
          <img
            src={profileImage}
            alt="Profile"
            className="profile-avatar"
          />

          <div>
            <h1>{formattedName}</h1>

            <div className="role-chip">
              <VerifiedUserIcon sx={{ fontSize: 14 }} />
              {roleName}
            </div>

            <div className="profile-contact-line">
              {email} • {phone}
            </div>
          </div>
        </div>

        <div
          className={`status-badge ${
            active ? "active" : "inactive"
          }`}
        >
          {active && <MdCheckCircle />}
          {active ? "Active" : "Inactive"}
        </div>
      </div>

      {/* Info Cards */}

      <div className="info-grid">
        <InfoCard
          icon={FaBuilding}
          title="Organization ID"
          value={orgId}
        />

        <InfoCard
          icon={FaBuilding}
          title="Process"
          value={processName}
        />

        <InfoCard
          icon={FaUsers}
          title="Department"
          value={department}
        />

        <InfoCard
          icon={FaUserTie}
          title="Designation"
          value={designation}
        />
      </div>

      {/* Contact */}

      <div className="section-card">
        <h2>Contact Information</h2>

        <div className="contact-grid">
          <ContactCard
            icon={MdEmail}
            label="Email Address"
            value={email}
          />

          <ContactCard
            icon={MdPhone}
            label="Phone Number"
            value={phone}
          />
        </div>
      </div>

      {/* Access */}

      <div className="section-card">
        <h2>Permissions & Access</h2>

        <div className="access-wrapper">
          <div className="access-block">
            <span className="access-title">
              Assigned Role
            </span>

            <div className="pill">
              {designation || "Not Available"}
            </div>
          </div>

          {role?.[0] !== "ROLE_CRM_ADMIN" && (
            <div className="access-block">
              <span className="access-title">
                Reporting To
              </span>

              <div className="pill">
                {reportingTo || "Not Available"}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyProfile;